import * as z from 'zod';

export const awardTypeQuerySchema = z.enum(['internal', 'joint_with_client']);

type TAwardTypeQuerySchema = z.infer<typeof awardTypeQuerySchema>;
export type AwardTypeMutationSchema = TAwardTypeQuerySchema;

export const awardTypeFormSchema = z.object({
  name: z.string(),
  value: awardTypeQuerySchema,
});

type AwardTypeFormSchema = z.infer<typeof awardTypeFormSchema>;

export const defaultAwardType = null;

export const awardTypeOptions: AwardTypeFormSchema[] = [
  { name: 'Internal', value: 'internal' },
  { name: 'Joint with Client', value: 'joint_with_client' },
];

export function strToAwardType(awardType: TAwardTypeQuerySchema | null): AwardTypeFormSchema | null {
  return awardTypeOptions.find((option) => option?.value === awardType) ?? null;
}

export function awardTypeToStr(awardType: AwardTypeFormSchema | null) {
  return awardType?.value ?? null;
}
